import axios from 'axios'

const deleteCountryFromPayment = async (data) => {
  console.log('delet')
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/deletePaymentFromCountry`,
      data,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    console.log('delet res', response)
    return response.data.msg
  } catch (error) {
    console.log('delet erro', error)
    throw error
  }
}

export default deleteCountryFromPayment
